import moment from 'moment';
import { createReducer } from 'typesafe-actions';
import withJobs from '../../_core/job/reducers';
import {
    IAnnex6Store,
} from './@types';
import annex6Actions, { EAnnex6Constants, TANNEX6Actions } from './actions';

const defaultState: IAnnex6Store = {
    _jobs: {},
    currentOperation: undefined,
    records: {
        byIds: {},
        ids: [],
    },
    filter: {
        startDate: moment().subtract(7, 'days').toDate(),
        endDate: moment().add(1, 'day').toDate(),
        shownRecords: 'ALL',
    },
    currentWeekReport: {
        recordedOperations: {},
        pendingApprovalsCount: 0,
        totalRecords: 0,
        strikedOffCount: 0,
        pendingVerificationsCount: 0,
        isLastRecordStrikedOff: false,
        isItSundayFirstHalf: false,
        isItSundaySecondHalf: false,
        isWeekEndDatePassed: false,
    },
    previousWeekReport: {
        recordedOperations: {},
        pendingApprovalsCount: 0,
        totalRecords: 0,
        strikedOffCount: 0,
        pendingVerificationsCount: 0,
        isLastRecordStrikedOff: false,
        isItSundayFirstHalf: false,
        isItSundaySecondHalf: false,
        isWeekEndDatePassed: false,
    },
    bdnReports: [],
};
const annex6Reducers = createReducer<IAnnex6Store, TANNEX6Actions>(defaultState)
    .handleAction(
        annex6Actions.document.historySet,
        function historySet(state, action) {
            return {
                ...state,
                records: action.payload.history,
            };
        }
    )
    .handleAction(
        annex6Actions.document.setFilter,
        function setFilter(state, action) {
            return {
                ...state,
                filter: action.payload.filter,
            };
        }
    );

export default withJobs<IAnnex6Store>(
    EAnnex6Constants.FEATURE,
    defaultState,
    annex6Reducers
);
